import { calculateDiscountPercentage } from "../../utils/utils";
import TypographyMontserrat from "../TypographyMontserrat";

const Badge = ({ customStyles, salePrice, actualPrice }) => {
    return (
        <div
            className={`bg-SALE w-[60px] h-[22px] flex justify-center items-center ${customStyles}`}
        >
            <TypographyMontserrat
                color={"White"}
                fontWeight="bold"
                text={
                    actualPrice &&
                    salePrice &&
                    calculateDiscountPercentage(actualPrice, salePrice)
                }
                customStyle={"text-[12px]"}
            />
        </div>
    );
};
export default Badge;
